import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c5203ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "l-container" }
const _hoisted_3 = {
  key: 0,
  class: "header-button-container"
}

import { getCurrentInstance, onMounted, ref, withDefaults, onRenderTriggered } from "vue";
    import { useI18n } from "vue-i18n";
    import { createAuthenticationService } from "@/services/authenticationService";
    import MobileMenu from "@/components/MobileMenu.vue";
    import { useRouter } from "vue-router";
    import { OhLogo } from "@onehiring/ui/icons";

    
export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
    showRegisterButton: { type: Boolean, default: false }
  },
  setup(__props: any) {

    

    const app = getCurrentInstance();
    const { t } = useI18n();
    const loggedIn = ref(false);
    const router = useRouter();

    const isMobile = () => window.innerWidth <= 639;


    const register = async () => {
        const authService = createAuthenticationService(app);
        authService.openRegistrationDialog(null);
    }
    const login = async () => {
        const authService = createAuthenticationService(app);
        authService.openLoginDialog(null);
    }
    const logout = async () => {
        const authService = createAuthenticationService(app);
        await authService.signOut();
        loggedIn.value = false;
    }
    const goToGateway = () => {
       router.push({ name: 'Home' });
    }

    const getLoginState = async () => {
        const authService = createAuthenticationService(app);
        loggedIn.value = authService.isAuthenticated();
    }

    onMounted(async () => {
        getLoginState();
    })

    onRenderTriggered(async () => {
        setTimeout(getLoginState, 500);
    })


return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "header-logo cursor-pointer",
        onClick: goToGateway
      }, [
        _createVNode(_unref(OhLogo))
      ]),
      (!isMobile())
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.showRegisterButton)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  onClick: register,
                  class: "button-secondary",
                  "data-cy": "button-register"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("register")), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_Button, {
              onClick: login,
              class: "button-secondary",
              "data-cy": "button-login"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("login")), 1)
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (isMobile())
              ? (_openBlock(), _createBlock(MobileMenu, {
                  key: 0,
                  loggedIn: loggedIn.value,
                  onRegister: register,
                  onLogin: login,
                  onLogout: logout
                }, null, 8, ["loggedIn"]))
              : _createCommentVNode("", true)
          ], 64))
    ])
  ]))
}
}

})